import React from 'react';
import classNames from 'classnames';
import { HexColorInput } from 'react-colorful';

type Props = {
  color?: string;
  onChange?: (color: string) => void;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onPreviewClick?: React.MouseEventHandler<HTMLDivElement>;
};

const ColorTextBox = ({ color, onPreviewClick, ...rest }: Props) => (
  <div className="color-textbox" onClick={onPreviewClick}>
    <div className={classNames('preview', { transparent: !color })} style={{ backgroundColor: color }} />
    <HexColorInput prefixed={!!color} color={color} {...rest} />
  </div>
);

export default ColorTextBox;
